import { render, staticRenderFns } from "./RiskDistribution.vue?vue&type=template&id=217905e4"
import script from "./RiskDistribution.vue?vue&type=script&lang=js"
export * from "./RiskDistribution.vue?vue&type=script&lang=js"
import style0 from "./RiskDistribution.vue?vue&type=style&index=0&id=217905e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports